import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Certifications from './components/Certifications';
import Education from './components/Education';

const Divider = () => (
  <hr style={{ border: 'none', borderTop: '1px solid var(--primary)', maxWidth: 'var(--max)', margin: '0 auto' }} />
);

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Divider />
        <About />
        <Divider />
        <Skills />
        <Divider />
        <Experience />
        <Divider />
        <Education />
        <Divider />
        <Projects />
        <Divider />
        <Certifications/>
        <Divider />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
